import React, { createContext, useState, useContext } from 'react';

const NotificationContext = createContext(null);
function NotificationProvider({ children }) {
    const [notification, setNotification] = useState(null);
    return (React.createElement(NotificationContext.Provider, { value: { notification, setNotification } }, children));
}
function useNotification() {
    return useContext(NotificationContext);
}

export { NotificationProvider, useNotification };
